import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import TimelineItem from "examples/Timeline/TimelineItem";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import colors from "assets/theme/base/colors";

function Activities({
  act_feed_message,
  act_feed_status,
  act_mortality_message,
  act_mortality_status,
  act_sanitation_message,
  act_sanitation_status,
  act_vaccination_message,
  act_vaccination_status,
  act_weight_message,
  act_weight_status,
  timestamp,
}) {
  const statusToColor = {
    Red: colors.error.main,
    Orange: colors.warning.main,
    Amber: colors.warning.main,
    Green: colors.success.main,
    Yellow: colors.warning.main,
    Neutral: colors.info.main,
  };

  const messageRef = useRef(null);
  const [shouldScroll, setShouldScroll] = useState(false);

  useEffect(() => {
    const el = messageRef.current;
    if (el && el.scrollWidth > el.clientWidth) {
      setShouldScroll(true);
    }
  }, [act_feed_message]);

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox pt={3} px={3}>
        <MDTypography variant="h6" fontWeight="medium">
          Recent Activities
        </MDTypography>
      </MDBox>
      <MDBox p={2}>
        <TimelineItem
          color={statusToColor[act_feed_status] || colors.light.main}
          title={act_feed_message || "loading..."}
          dateTime={timestamp || ""}
        />
        <TimelineItem
          color={statusToColor[act_mortality_status] || colors.light.main}
          title={act_mortality_message || "loading..."}
          dateTime={timestamp || ""}
        />
        <TimelineItem
          color={statusToColor[act_weight_status] || colors.light.main}
          title={act_weight_message || "loading..."}
          dateTime={timestamp || ""}
        />
        <TimelineItem
          color={statusToColor[act_vaccination_status] || colors.light.main}
          title={
            <MDBox
              sx={{
                overflow: "hidden",
                whiteSpace: "nowrap",
                width: "100%",
              }}
            >
              <MDTypography
                variant="button"
                fontWeight="bold"
                sx={{
                  display: "inline-block",
                  animation: "scroll-left 15s linear infinite",
                }}
              >
                {act_vaccination_message || "loading..."}
              </MDTypography>
            </MDBox>
          }
          dateTime={timestamp || ""}
        />
        <TimelineItem
          color={statusToColor[act_sanitation_status] || colors.light.main}
          title={
            <MDBox
              sx={{
                overflow: "hidden",
                whiteSpace: "nowrap",
                width: "100%",
              }}
            >
              <MDTypography
                variant="button"
                fontWeight="bold"
                sx={{
                  display: "inline-block",
                  animation: "scroll-left 10s linear infinite",
                }}
              >
                {act_sanitation_message || "loading..."}
              </MDTypography>
            </MDBox>
          }
          dateTime={timestamp || ""}
          lastItem
        />
      </MDBox>
    </Card>
  );
}

Activities.propTypes = {
  act_feed_message: PropTypes.string,
  act_feed_status: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  act_mortality_message: PropTypes.string,
  act_mortality_status: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  act_sanitation_message: PropTypes.string,
  act_sanitation_status: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  act_vaccination_message: PropTypes.string,
  act_vaccination_status: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  act_weight_message: PropTypes.string,
  act_weight_status: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  timestamp: PropTypes.string,
};

export default Activities;
